import React, { useState } from "react";
import TabSection from "./TabSection";
import SectionHeader from "./SectionHeader";
import { showSectionHeader } from "../../../utils/formGenUtils/showSectionHeader";
import { useIncidentFormContext } from "./IncidentContext";
import { FormikValues, useFormikContext } from "formik";
import DisableSectionFlag from "./DisableSectionFlag";

const FormSection = ({ sections }: any) => {
  const { viewModel } = useIncidentFormContext();
  const { values, setFieldValue } = useFormikContext<FormikValues>();
  const [hiddenTabs, setHiddenTabs] = useState([]);
  const sectionKeys = Object.keys(sections);
  function handleCollapseSection(key: string) {
    const hiddenTabs__c = [...hiddenTabs];
    const checkState = hiddenTabs__c.find((item) => item === key);
    if (!checkState) {
      //@ts-ignore
      hiddenTabs__c.push(key);
      setHiddenTabs(hiddenTabs__c);
      return;
    }

    //@ts-ignore
    const filterSection = hiddenTabs__c.filter((item) => item !== key);
    setHiddenTabs(filterSection);
  }

  function isSectionVisible(key: string) {
    const check = hiddenTabs.find((item) => item === key);
    if (check) return false;
    return true;
  }
  
  return (
    <>
      {sectionKeys.map((sectionKey, index) => {
        // Get the section data
        const section = sections[sectionKey];
        
        // Create the toggle component if section has a toggle
        let toggleComponent = null;
        if (section.hasToggle) {
          // Find the section level toggle field in this section
          const toggleField = section.fields.find(
            (field: any) => field.fieldType === "Togglebox" && !field.parentFieldId
          );
          
          if (toggleField) {
            const fieldName = toggleField.fieldName;
            const fieldLabel = toggleField.fieldLabel || '';
            // Get the field value safely, default to false if undefined
            const fieldValue = values[fieldName] || false;
            
            toggleComponent = (
              <DisableSectionFlag
                name={fieldName}
                label={fieldLabel}
                sectionName={sectionKey}
                value={fieldValue}
                onChange={() => setFieldValue(fieldName, !fieldValue)}
                disabled={false}
              />
            );
          }
        }
        
        return (
          <div key={sectionKey}>
            {showSectionHeader(sections, sectionKey, viewModel) && (
              <SectionHeader
                handleCollapse={handleCollapseSection}
                sectionKey={sectionKey}
                isOpen={isSectionVisible(sectionKey)}
                toggleComponent={toggleComponent}
              />
            )}

            <TabSection
              section={section.fields.filter((field: any) => 
                !(field.fieldType === "Togglebox" && !field.parentFieldId) // This filters out section level toggles
              )}
              isOpened={isSectionVisible(sectionKey)}
              index={sectionKeys.length - index}
            />
          </div>
        );
      })}
    </>
  );
};

export default FormSection;
